import { BaseType } from '../../../base/base-type';

export class GoverningJurisdictionType extends BaseType {
  public shortCode!: string;
}
